// extracted by css-extract-rspack-plugin
export default {"avatar":"avatar-ZXOsA","mask":"mask-aORjw","upload-mask":"upload-mask-nMn7F","uploadMask":"upload-mask-nMn7F","image":"image-jjpFu","name":"name-dpGqS","loading":"loading-Fqj_0"};